export const WhyUs = () => {
  const items = [
    {
      title: "Berizin Resmi Kemenag",
      desc: "PPIU & PIHK Terdaftar",
    },
    {
      title: "Partner Resmi Arab Saudi",
      desc: "Kerjasama Langsung & Terpercaya",
    },
    {
      title: "Bonus Jamaah Lengkap",
      desc: "Perlengkapan & Benefit Eksklusif",
    },
    {
      title: "Hotel Berkualitas",
      desc: "Nyaman dan Strategis",
    },
    {
      title: "Pendamping Berpengalaman",
      desc: "Muthawif & Tim Profesional",
    },
    {
      title: "Konsultasi Responsif",
      desc: "Siap Membantu Setiap Saat",
    },
  ];

  return (
    <section
      id="why-us"
      className="scroll-mt-32 py-20 bg-white"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-12">

        <div className="text-center mb-12">
          <h2 className="font-serif-display text-primary text-4xl">
            Mengapa Memilih Baba Tour
          </h2>

          <p className="text-muted mt-4 max-w-2xl mx-auto">
            Komitmen kami adalah memberikan pelayanan terbaik,
            pendampingan profesional, dan pengalaman ibadah yang
            nyaman bagi setiap jamaah.
          </p>
        </div>

        <div className="grid grid-cols-2 md:grid-cols-3 gap-5">

          {items.map((item, index) => (
            <div
              key={index}
              className="border border-soft rounded-2xl p-6 text-center hover:shadow-lg transition"
            >
              <div className="text-2xl mb-3 text-accent">
                ✓
              </div>

              <div className="font-semibold text-primary">
                {item.title}
              </div>

              <div className="text-sm text-muted mt-2">
                {item.desc}
              </div>
            </div>
          ))}

        </div>

      </div>
    </section>
  );
};
